import { useCallback, useEffect, useState } from "react";

const isNewerVersion = (latest, current) => {
  const toParts = (value) => String(value || "").split(".").map((part) => Number(part));
  const next = toParts(latest);
  const active = toParts(current);
  if (next.some(Number.isNaN) || active.some(Number.isNaN)) return false;
  const length = Math.max(next.length, active.length);
  for (let index = 0; index < length; index += 1) {
    const difference = (next[index] || 0) - (active[index] || 0);
    if (difference !== 0) return difference > 0;
  }
  return false;
};

export const useVersionCheck = (currentVersion, intervalMs = 60000) => {
  const [latestVersion, setLatestVersion] = useState(null);

  const checkVersion = useCallback(async () => {
    try {
      const response = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
      if (!response.ok) return;
      const data = await response.json();
      setLatestVersion(isNewerVersion(data.version, currentVersion) ? data.version : null);
    } catch (error) {
      console.debug("Version check unavailable", error);
    }
  }, [currentVersion]);

  useEffect(() => {
    checkVersion();
    const timer = window.setInterval(checkVersion, intervalMs);
    const checkWhenVisible = () => {
      if (document.visibilityState === "visible") checkVersion();
    };
    window.addEventListener("focus", checkVersion);
    document.addEventListener("visibilitychange", checkWhenVisible);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener("focus", checkVersion);
      document.removeEventListener("visibilitychange", checkWhenVisible);
    };
  }, [checkVersion, intervalMs]);

  return latestVersion;
};